<template>
  <main class="tk-product-wrapper">
    <!-- Back button -->
    <button class="tk-back-button btn" @click="handleBackButton()">
      <img
        data-v-22b8f552=""
        src="@/assets/icons/ui/chevron-back-outline.png"
        alt="back arrow"
      />
      <span>back to browsing</span>
    </button>
    <div class="tk-product">
      <!-- Header -->
      <section class="tk-product-header">
        <div class="tk-product-header-product-name">
          <img
            v-if="activeProduct && activeProduct.brand"
            :src="
              require(`@/assets/branding/${activeProduct.brand
                .replace(/\s+/g, '-')
                .toLowerCase()}.png`)
            "
            alt="branding"
          />
          <h1 class="forza-bold">
            {{ activeProduct.name }}
          </h1>
          <p class="forza-bold">
            {{
              activeProduct.style_id ||
              activeProduct.style_name ||
              activeProduct.styleId ||
              activeProduct.alias
            }}
          </p>
        </div>

        <div class="save-roster-container">
          <button class="btn btn-save-roster" @click="saveSelection()">
            <img
              src="@/assets/icons/ui/list-outline-white.svg"
              alt="save selection"
            />Save Size Selection
          </button>
        </div>
      </section>
      <section class="tk-product-content">
        <!-- Selection checkboxes -->
        <div class="checkboxes-container">
          <p>Available In:</p>

          <div class="checkboxes">
            <label
              v-for="(pr, i) in products"
              :key="i + '-pr-checkbox'"
              :for="i + '-pr-checkbox'"
            >
              <input
                type="checkbox"
                :name="i + '-pr-checkbox'"
                :id="i + '-pr-checkbox'"
                v-model="pr.selected"
                :disabled="pr.disabled"
                @change="(e) => handleCheckboxChange(e, pr)"
              />
              <span>{{ pr.gender }} ({{ pr.styleId }})</span>
            </label>
          </div>
        </div>

        <!-- Product Container -->
        <div
          class="product-row"
          v-for="(pr, i) in products.filter((pr) => pr && pr.selected)"
          :key="i + '-pr-row'"
        >
          <h3 class="forza-bold">{{ pr.alias }} - {{ pr.gender }}</h3>

          <div class="selections-container">
            <div
              class="quantity-container"
              v-for="(s, i) in pr.sizes"
              :key="i + '-pr-size'"
            >
              <!-- Size -->
              <span class="forza-bold gender-id">{{ s.size }}</span>
              <span v-if="showProjectPrices"
                >${{
                  (s.quantity
                    ? s.quantity * (s.price + decorationsPrice)
                    : s.price + decorationsPrice
                  ).toFixed(2)
                }}</span
              >
              <input
                type="number"
                v-model="s.quantity"
                @keydown="(e) => handlePreventDecimals(e)"
                @input="updateDecorationPrices()"
              />
            </div>
          </div>
        </div>
      </section>
    </div>

    <transition name="fade">
      <div class="tk-modal-loader" v-if="loadingThreekit">
        <Loader :withMessage="true" :message="threekitLoaderMessage" />
      </div>
    </transition>

    <transition name="fade">
      <ModalAlert
        v-if="showConfirmationModal"
        :darker="true"
        :title="'Warning: No quantity selected'"
        :text="'Are you sure you want to leave all the items blank?'"
        :confirmationText="'Confirm & Save'"
        :showButtons="true"
        @closeModal="showConfirmationModal = false"
        @confirm="redirectToLocker()"
      />
    </transition>

    <transition name="fade">
      <ModalAlert
        v-if="showAlertModal"
        :isError="true"
        :darker="true"
        :title="'Error'"
        :text="'Something went wrong. Please try again later.'"
        @closeModal="showAlertModal = false"
      />
    </transition>
  </main>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import Loader from "@/components/Utils/Loader";
import ModalAlert from "@/components/Utils/ModalAlert.vue";
import axios from "axios";
import { debounce } from "debounce";
export default {
  name: "SizesSelection",

  components: {
    Loader,
    ModalAlert,
  },

  data() {
    return {
      products: [],
      showConfirmationModal: false,
      showAlertModal: false,
      loading: false,
      upcharges: {
        "2XL": 1.5,
        "3XL": 3,
        "4XL": 4.5,
        "5XL": 6,
      },
      sizesOrder: [
        "XXS",
        "XS",
        "S",
        "M",
        "L",
        "XL",
        "2XL",
        "3XL",
        "4XL",
        "5XL",
        "6XL",
      ],
    };
  },

  computed: {
    ...mapState(["auth", "dealer", "settings"]),
    ...mapState("project", ["activeProduct"]),
    ...mapState("threekit", ["decorationsPrice"]),
    ...mapState("threekit", {
      loadingThreekit: (state) => state.loading,
      threekitLoaderMessage: (state) => state.loadingMessage,
    }),
    ...mapGetters("lockerModule", ["lockerCode"]),
    ...mapGetters("project", ["showProjectPrices"]),
    ...mapGetters("threekit", ["isSublimated3D"]),

    productDecorations() {
      return this.activeProduct?.threekit_decorations;
    },

    productGenders() {
      return this.activeProduct?.related?.map((r) => r?.relGender);
    },

    totalQuantity() {
      const sizes = this.products
        ?.filter((item) => item.selected)
        ?.map((item) => {
          return item.sizes;
        })
        ?.flat();

      const quantity = sizes.reduce((acc, size) => {
        return Number(acc) + Number(size.quantity);
      }, 0);

      return quantity;
    },
  },

  methods: {
    ...mapActions("project", [
      "getProductByStyleId",
      "getProductSizesPrice",
      "redirectToLocker",
      "updateBuilderRosterOrSizes",
    ]),
    ...mapActions("lockerModule", ["getLockerByCode"]),
    ...mapActions("threekit", [
      "close3DDecorations",
      "getDecorationPrices",
      "setLoadingState",
    ]),

    checkSelection(forceHideConfirmationModal) {
      const allBoxesAreEmpty = this.products
        ?.filter((item) => item.selected)
        ?.map((item) => {
          return item.sizes;
        })
        ?.flat()
        .every((selection) => !selection.quantity);

      if (forceHideConfirmationModal) {
        return true;
      } else if (allBoxesAreEmpty && !forceHideConfirmationModal) {
        this.showConfirmationModal = true;
      }

      return allBoxesAreEmpty ? false : true;
    },

    handleBackButton() {
      this.$router.go(-1);
    },

    handleUpdateProductQuantity(e, s) {
      console.log({ v: e.target.value, e, s });
    },
    handlePreventDecimals(e) {
      var invalidChars = ["-", "+", "e", "."];
      if (invalidChars.includes(e.key)) {
        e.preventDefault();
      }
    },

    async initializeSizes() {
      try {
        this.setLoadingState({
          loadingState: true,
          message: "Calculating prices...",
        });

        //Get the original product data
        const productData = await this.getProductByStyleId(
          this.activeProduct?.style_id || this.activeProduct?.style_name
        );

        if (productData) {
          const sizes = await this.getProductSizesPrice(productData?.style_id);
          let orderedSizes = [];

          sizes.forEach((sizeItem) => {
            const index = this.sizesOrder.findIndex((orderedSize) => {
              return orderedSize === sizeItem.size;
            });

            orderedSizes[index] = sizeItem.size;
          });

          orderedSizes = orderedSizes.filter((s) => s);

          const originalProduct = {
            alias: productData.alias,
            gender: productData.gender,
            styleId: productData?.style_id,
            sizes: orderedSizes?.map((size) => {
              const basePrice = Number(
                sizes.find((sizeItem) => {
                  return sizeItem?.size === "M";
                })?.price
              );
              const sizePrice = Number(
                sizes.find((sizeItem) => sizeItem?.size === size)?.price
              );
              const upcharge = sizePrice - basePrice;
              return {
                size: size,
                price: Number(this.activeProduct.productPrice) + upcharge,
                quantity: 0,
              };
            }),
            selected: true,
            disabled: true,
          };

          this.products.push(originalProduct);

          // Get the related products data
          const relatedProducts = productData.related_data?.filter(
            (r) => r?.style_id !== originalProduct?.styleId
          );

          if (relatedProducts && relatedProducts.length > 0) {
            for (const related of relatedProducts) {
              const relatedProductData = await this.getProductByStyleId(
                related.style_id
              );
              if (relatedProductData) {
                const sizes = await this.getProductSizesPrice(
                  relatedProductData?.style_id
                );

                let orderedSizes = [];

                sizes.forEach((sizeItem) => {
                  const index = this.sizesOrder.findIndex((orderedSize) => {
                    return orderedSize === sizeItem.size;
                  });

                  orderedSizes[index] = sizeItem.size;
                });

                orderedSizes = orderedSizes.filter((s) => s);

                const product = {
                  alias: relatedProductData?.alias,
                  gender: relatedProductData?.gender,
                  styleId: relatedProductData?.style_id,

                  sizes: orderedSizes?.map((size) => {
                    const basePrice = Number(
                      sizes.find((sizeItem) => {
                        return sizeItem?.size === "M";
                      })?.price
                    );
                    const sizePrice = Number(
                      sizes.find((sizeItem) => sizeItem?.size === size)?.price
                    );
                    const upcharge = sizePrice - basePrice;
                    return {
                      size: size,
                      price: Number(this.activeProduct.productPrice) + upcharge,
                      quantity: 0,
                    };
                  }),
                  selected: false,
                };
                this.products.push(product);
              }
            }
          }
          await this.updateDecorationPrices();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.setLoadingState({
          loadingState: false,
        });
      }
    },

    async saveSelection(forceHideConfirmationModal = false) {
      if (forceHideConfirmationModal) {
        this.showConfirmationModal = false;
      }
      if (this.checkSelection(forceHideConfirmationModal)) {
        this.setLoadingState({
          loadingState: true,
          message: "Saving changes",
        });

        try {
          const url =
            this.settings.endpoint +
            `api/v2/lockers/item/roster/${this.activeProduct["lockerProductId"]}`;

          const settings = {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.auth.apiToken,
            },
          };

          const params = {
            quantity: this.totalQuantity,
            sizes_selection: this.products,
            roster: null,
          };

          this.loading = true;

          await axios.put(url, params, settings);
          await this.updateBuilderRosterOrSizes({
            ...this.activeProduct,
            sizes_selection: this.products,
          });
          await this.getLockerByCode(this.lockerCode);
          this.redirectToLocker();
        } catch (error) {
          console.log("error trying to save roster", error);
          this.showAlertModal = true;
        } finally {
          this.setLoadingState({
            loadingState: false,
          });
        }
      }
    },

    async handleCheckboxChange(e, pr) {
      const { checked } = e.target;
      //Clear the sizes of this product that has been unchecked
      if (!checked) {
        pr.sizes = pr.sizes.map((s) => {
          return {
            ...s,
            quantity: 0,
          };
        });
      }

      //Replace it on state
      this.products = this.products.map((p) => {
        if (p.styleId === pr.styleId) {
          return pr;
        }
        return p;
      });

      await this.updateDecorationPrices();
    },

    updateDecorationPrices: debounce(async function () {
      if (!this.isSublimated3D)
        try {
          this.setLoadingState({
            loadingState: true,
            message: "Calculating prices...",
          });

          await this.getDecorationPrices({
            decorations: this.productDecorations,
            quantity: this.totalQuantity,
          });
        } catch (error) {
          console.log(error);
        } finally {
          this.setLoadingState({
            loadingState: false,
          });
        }
    }, 500),
  },

  async mounted() {
    this.activeProduct.sizes_selection
      ? (this.products = await JSON.parse(this.activeProduct.sizes_selection))
      : await this.initializeSizes();
  },

  beforeDestroy() {
    this.close3DDecorations();
  },
};
</script>
<style lang="scss" scoped>
.tk-back-button {
  border-radius: 5px;
  display: block;
  padding: 0.2rem;
  transition: all 0.1s;
  text-transform: capitalize;
  background: transparent;
  display: flex;
  align-items: center;
  cursor: pointer;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  margin-bottom: 1rem;
  text-decoration: none;
  text-transform: uppercase;
}
.spinner-loader-container {
  margin: auto;
}
.tk-product-wrapper {
  position: relative;
  margin: auto;
  max-width: 1920px;
  padding-top: 1rem;
  width: 90%;
}
.tk-product {
  // height: 90vh;
  // max-height: 900px;
  margin: auto;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 3px;
  border: 1px solid $borderColor;
  margin-bottom: 1rem;

  .tk-product-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: $grey-lightest;
    border-bottom: 1px solid $borderColor;
    height: 5rem;

    .tk-product-header-product-name {
      display: flex;
      align-items: center;
      padding: 1.5rem;
      width: 50%;
      height: 100%;
      * {
        margin-right: 1.5rem;
      }
      h1 {
        margin-right: 0.5rem;
        font-size: 1.75rem;
      }
      p {
        font-size: 1.25rem;
        color: $grey-dark;
        margin: 0;
      }
      img {
        max-width: 30%;
        max-height: 100%;
      }
    }

    #tk-product-steps {
      display: flex;
      padding-top: 0;
      width: 50%;
      justify-content: space-between;
      .navigation-item {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-evenly;
        width: 30%;
        cursor: pointer;
        position: relative;
        transition: text-decoration 0.2s;
        overflow: hidden;
        &:hover {
          text-decoration: underline;
        }

        &.disabled {
          pointer-events: none;
          cursor: not-allowed;
          opacity: 0.5;
        }

        &.active {
          .border-bottom {
            border-color: $playbookColor;
            visibility: visible;
          }
          .navigation-check {
            border: 2px solid $playbookColor;
          }
        }

        .navigation-label {
          transition: text-decoration 0.2s;
          font-size: 1.1rem;
          /* text-transform: uppercase; */
        }

        .navigation-check {
          width: 21px;
          height: 21px;
          border-radius: 50%;
          border: 2px solid rgba(236, 237, 237, 1);
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.1s;
          &.checked {
            background: transparent;
            border: 2px solid $playbookColor;
            .checkmark {
              /* display: inline-block; */
              transform: rotate(45deg);
              height: 9px;
              width: 4px;
              margin-bottom: 2px;
              margin-left: 1px;
              border-bottom: 1px solid $playbookColor;
              border-right: 1px solid $playbookColor;
              transition: all 0.1s;
            }
          }
        }

        .border-bottom {
          border-radius: 20px;
          border-top: 4px solid transparent;
          height: 10px;
          margin: 0 auto;
          width: 100%;
          visibility: hidden;
          position: absolute;
          bottom: -7px;
          left: 0;
          right: 0;
          transition: all 0.1s;
        }
      }
    }
  }

  .save-roster-container {
    margin-right: 2rem;
    .btn {
      background-color: $playbookColor;
      color: white;
      img {
        margin-right: 0.5rem;
      }
    }
  }

  .tk-product-content {
    display: flex;
    flex-direction: column;
    height: 90%;
    padding: 1.5rem 3rem;

    .checkboxes-container {
      display: flex;
      margin-bottom: 2rem;
      * {
        text-transform: uppercase;
      }
      p {
        margin-right: 2rem;
        font-size: 1.1rem;
      }

      .checkboxes {
        display: flex;
        gap: 1rem;
        label {
          display: flex;
          align-items: center;
          margin-bottom: 0;
          margin-right: 2rem;
          input {
            margin-right: 0.5rem;
            width: 0.9rem;
          }
        }
      }
    }
    .product-row {
      border-bottom: 1px solid $borderColor;
      padding: 1rem;
      margin-bottom: 2rem;
      h3 {
        margin-bottom: 1.5rem;
        font-size: 1.25rem;
        text-transform: uppercase;
      }

      .selections-container {
        display: flex;
        flex-wrap: wrap;
        justify-content: start;
        gap: 3rem;

        .quantity-container {
          display: flex;
          flex-direction: column;
          flex-wrap: wrap;
          align-items: flex-start;
          justify-content: space-between;
          height: 100%;
          width: 6rem;

          @media screen and (max-width: 1366px) {
            width: 8%;
          }

          span {
            margin-bottom: 1rem;
          }
          span.gender-id {
            font-size: 1.75rem;
          }

          input {
            padding: 0.5rem 0.75rem;
            background: white;
            border: 1px solid $grey-light;
            border-radius: 6px;
            height: 2.8rem;
            width: 100%;
          }
        }
      }
    }
  }

  @media screen and (max-width: 1024px) {
    width: 90vw;
  }
}
.tk-modal-loader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  background: rgba(255, 255, 255, 0.5);
  z-index: 100;
}
</style>
